import React, { Component } from "react";
import DKIcon from "./common/DKIcon";
import ic_piyush_1 from "../assets/ic_piyush_1.png";
import DKLabel from "./common/DKLabel";
import DKButton from "./common/DKButton";

import { DKIcons } from "../Constants/DKIcons";
import SkillsRow from "./SkillsRow";
import { SKILLS } from "../Constants";

class About extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div className="column">
        <div className="row align-items-start">
          <DKIcon src={ic_piyush_1} className="ic-xl border-m circle" />
          <div className="column ml-r">
            <div className="row mt-r">
              <DKLabel text="Piyush Kandrikar" className="fw-m fs-xl " />
              <DKButton icon={DKIcons.ic_linkedin} className="" />
            </div>
            <DKLabel
              text="Web & Mobile apps development | UI/UX specialist"
              className="mt-xs"
            />

            <div className="row mt-m flex-wrap align-items-start">
              <DKButton
                title="pkandrikar@gmail.com"
                icon={DKIcons.ic_email}
                className="bg-gray1s mr-r mb-r border-m"
              />
              <DKButton
                title="+65 9350 9479"
                icon={DKIcons.ic_phone}
                className="bg-gray1s mr-r mb-r border-m"
              />
              <DKButton
                title="Singapore"
                icon={DKIcons.ic_location}
                className="bg-gray1s border-m"
              />
            </div>
            <SkillsRow
              skills={[
                SKILLS.UI_UX,
                SKILLS.REACT,
                SKILLS.REACT_NATIVE,
                SKILLS.IOS,
                SKILLS.ANDROID,
                SKILLS.JAVASCRIPT,
                SKILLS.HTML,
                SKILLS.CSS,
                SKILLS.MAC,
              ]}
              className="mt-s"
            />
          </div>
        </div>
        <DKLabel
          text="<b>👋 Hello there,</b><br>I am a tech & UI/UX enthusiast with an experience of over twelve years in Mobile/Web industry and expertise in targeting React JS, iOS, Android, React-Native Mac OS X, Watch OS, Cocos2D-X, Android and Online platforms. I understand the importance of creating highly readable and easily maintainable source code and user friendly UI. I am constantly striving to learn new technologies and look to ways to better myself in this rapidly changing industry.<br><br><b>Responsibilities Involved</b><br> • Lead projects effectively 🔥<br>
                        • Technical architecture & development 💪<br>
                        • UI/UX designing of apps ❤️<br>
                        • Team task and resource management 🗝<br>
                        • Involved in coding & code review process 🎉<br>
                        • Co-ordination between Tech, UI & Marketing 📌<br>"
          className=" p-l border-radius-s mt-xxl bg-gray1"
          //   style={{ backgroundColor: "rgb(242, 248, 250)" }}
        />
      </div>
    );
  }
}

export default About;
